/**
 * Created by Ivan on 04.03.2026
 */

const SoftConversionWindow = Prefab.createWindow("soft_conversion_window", "soft_conversion_window_prefab_json");
